module.exports = __webpack_public_path__ + "static/media/us-east-1-map-green.3d14ea78.svg";